export const message = (text: string) => {
  const tips = document.getElementById('tips');
  if (tips) {
    tips.remove();
  }

  const template = `<div class="toolTips"  id='tips'> ${text} </div>`
  let tempNode = document.createElement('div');
  tempNode.className = "tipsParent";
  tempNode.innerHTML = template;
  const app = document.getElementById('app');
  
  app && app.appendChild(tempNode);
  setTimeout(() => {
    tempNode.remove();
  }, 1500)
}

export const getRem = () => {
  const width = document.body.clientWidth;
  let rem = 10;
  if (width >= 1920) {
    rem = 12;
  }
  if (width >= 1600 && width < 1920) {
    rem = 11;
  }
  if (width >= 1200 && width < 1600) {
    rem = 10;
  }
  if (width >= 1024 && width < 1200) {
    rem = 8;
  }
  if (width < 1024) {
    rem = 7;
  }
  return rem;
}